import React from 'react';

// @ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';

interface IProps {
  theme?: string;
}

class BackButton extends React.Component<IProps>{

  constructor(props:IProps) {
      super(props);
  }

  goBack = () =>{
    if(typeof window !== "undefined"){
      if(window.history){
        if(window.history.back){
          window.history.back()
        }
      }
    }
  }

  render() {
    let headerHeight:any = 100;
    if(typeof window !== "undefined"){
      if(window.outerWidth < 800){
        headerHeight = 100;
      }
    }
    return (
      <div className="back-button" onClick={this.goBack} style={{top:headerHeight}}>
        {this.props.theme == "light" ?
          <img className="back-button-icon white-background shadow circle" src={GeneralAssetUrl+"back-black.png" }/>
        : <img className="back-button-icon black-background shadow circle" src={GeneralAssetUrl+"back-white.png" } />
        }
      </div>
    );
  }
}

 export default BackButton;
